import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import "./index.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import store from "./store";
// import { Provider } from "react-redux";
import HomeScreen from "./pages/HomePage/HomePage";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Compliance from "./pages/Compliance/Compliance";
import About from "./pages/AboutPage/About";
import WhatWeDoPage from "./pages/WhatWeDoPage/WhatWeDoPage";
import ProductPage from "./pages/ProductPage/ProductPage";
import ContactPage from "./pages/ContactPage/ContactPage";

// Define the router with routes
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route index element={<HomeScreen />} />
      <Route path="/about" element={<About />} />
      <Route path="/home" element={<HomeScreen />} />
      <Route path="/what-we-do" element={<WhatWeDoPage />} />
      <Route path="/product" element={<ProductPage />} />
      <Route path="/contact" element={<ContactPage />} />
      {/* <Route path="/contact" element={<Contact />} /> */}
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/compliance" element={<Compliance />} />
    </Route>
  )
);

// Render the application
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  // <Provider>
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
  // </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
